import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { computed, makeAutoObservable } from 'mobx';
import { SpecialSportsState } from 'src/AppState/CmsState/SpecialSportsState/SpecialSportsState';
import {
    FilterLabelWrapper,
    FilterLabel,
    ActionButtonsWrapper,
    TrashIconWrapper,
    DragAndDropIconWrapper,
    MovableHandleWrapper,
} from 'src/main/cms/Sports/SportsForm/SportsFilters/SportsFilters.style';

interface PropsTypes {
    slug: string;
    isDragged: boolean;
}

class State {
    constructor(
        private readonly slug: string,
        private readonly specialSportsState: SpecialSportsState
    ) {
        makeAutoObservable(this);
    }

    setActiveFilter = (): void => {
        if (this.specialSportsState !== null) {
            this.specialSportsState.onActiveFilter(this.slug);
        }
    };

    handleRemoveFilter = (): void => {
        if (this.specialSportsState !== null) {
            this.specialSportsState.onRemoveFilter(this.slug);
        }
    };

    @computed public get isOpen(): boolean {
        if (this.specialSportsState !== null) {
            return this.specialSportsState.activeFilter === this.slug;
        }
        return false;
    }
}

export const SpecialSportsFilterItem = observer(({ slug, isDragged }: PropsTypes) => {
    const { cmsState } = useAppStateContext();
    const { specialSportsState } = cmsState;
    const [state] = useState(() => new State(slug, specialSportsState));
    const { isOpen } = state;
    const filter = specialSportsState.filtersMap.get(slug) ?? null;

    if (filter === null) {
        return null;
    }

    return (
        <FilterLabelWrapper
            onClick={state.setActiveFilter}
            isActive={isOpen}
        >
            <FilterLabel>
                {filter.label} - {filter.competitionIds.length}
            </FilterLabel>
            <ActionButtonsWrapper>
                <TrashIconWrapper onClick={state.handleRemoveFilter} />
                <MovableHandleWrapper data-movable-handle>
                    <DragAndDropIconWrapper isDragged={isDragged} />
                </MovableHandleWrapper>
            </ActionButtonsWrapper>
        </FilterLabelWrapper>
    );
});
